// MARK://dhk8/admin-shell/lib/queries/waitlist
// Query tipada de fila de espera - F9.5 / ADR-0009. El Admin lee la cola por el
// grafo (pos-floor), tenant del JWT (RLS). Mismo campo waitlist que ya consume
// el POS (apps/pos/src/lib/queries/floor.queries.ts).
// F9.17 / ADR-0008: escrituras también por el grafo (addWaitlistEntry /
// notifyWaitlistEntry / leaveWaitlistEntry). El tenantId lo pone el JWT (no va en input).
//
// Ciclo de vida completo (state machine WAITING→NOTIFIED→SEATED/LEFT/EXPIRED): el
// admin maneja las MISMAS acciones que el POS — seatWaitlistEntry (abre sesión de
// mesa), moveWaitlistEntry (reordena up/down) y noShowAttemptWaitlistEntry (sin
// respuesta; al 3er intento → EXPIRED). Copiamos el shape EXACTO de pos-floor
// (services/pos-floor/src/api/graphql.ts) — la entrada NO es editable (name/phone/
// partySize inmutables), solo se transiciona de estado.
import { graphql } from '../../gql/index.js'

export const AdminWaitlistQuery = graphql(`
  query AdminWaitlist($branchId: String, $status: String, $includeHistory: Boolean) {
    waitlist(branchId: $branchId, status: $status, includeHistory: $includeHistory) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`)

export const AdminAddWaitlistEntryMutation = graphql(`
  mutation AdminAddWaitlistEntry($input: PosCreateWaitlistInput!) {
    addWaitlistEntry(input: $input) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`)

export const AdminNotifyWaitlistEntryMutation = graphql(`
  mutation AdminNotifyWaitlistEntry($id: ID!) {
    notifyWaitlistEntry(id: $id) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`)

export const AdminLeaveWaitlistEntryMutation = graphql(`
  mutation AdminLeaveWaitlistEntry($id: ID!) {
    leaveWaitlistEntry(id: $id) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`)

// Sienta la entry abriendo sesión de mesa. input.serverId es REQUERIDO (ID!) en el
// contrato de pos-floor; tableId también (ID!); covers es opcional. → SEATED.
export const AdminSeatWaitlistEntryMutation = graphql(`
  mutation AdminSeatWaitlistEntry($id: ID!, $input: PosSeatWaitlistInput!) {
    seatWaitlistEntry(id: $id, input: $input) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`)

// Reordena la entry en la cola. direction: 'UP' | 'DOWN' (String! en el contrato).
export const AdminMoveWaitlistEntryMutation = graphql(`
  mutation AdminMoveWaitlistEntry($id: ID!, $direction: String!) {
    moveWaitlistEntry(id: $id, direction: $direction) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`)

// Intento sin respuesta (cliente no contesta tras notificar). Al 3er intento la
// entry pasa a EXPIRED; antes incrementa noShowAttempts y la mantiene en cola.
export const AdminNoShowAttemptWaitlistEntryMutation = graphql(`
  mutation AdminNoShowAttemptWaitlistEntry($id: ID!) {
    noShowAttemptWaitlistEntry(id: $id) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`)
